var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaystore(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 45,
    viewBox: "0 0 150 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#prefix__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M144.444 44.452H5.556C2.444 44.452 0 42.008 0 38.897V5.563C0 2.453 2.444.008 5.556.008h138.888c3.112 0 5.556 2.444 5.556 5.555v33.334c0 3.11-2.444 5.555-5.556 5.555z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.444.897c2.556 0 4.667 2.11 4.667 4.666v33.334c0 2.555-2.111 4.666-4.667 4.666H5.556C3 43.563.889 41.453.889 38.897V5.563C.889 3.008 3 .897 5.556.897h138.888zm0-.89H5.556C2.444.008 0 2.564 0 5.564v33.334c0 3.11 2.444 5.555 5.556 5.555h138.888c3.112 0 5.556-2.444 5.556-5.555V5.563c0-3-2.444-5.555-5.556-5.555z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.667 11.341c0 .889-.223 1.667-.778 2.222-.667.667-1.445 1-2.445 1-1 0-1.777-.333-2.444-1-.667-.666-1-1.444-1-2.444s.333-1.778 1-2.445c.667-.666 1.444-1 2.444-1 .445 0 .89.112 1.334.334.444.222.778.444 1 .778l-.556.555c-.444-.555-1-.778-1.778-.778-.666 0-1.333.223-1.777.778-.556.445-.778 1.111-.778 1.889s.222 1.444.778 1.889c.555.444 1.11.778 1.777.778.778 0 1.334-.223 1.89-.778a1.84 1.84 0 00.555-1.333h-2.445v-.89h3.223v.445zm5.11-2.778h-3v2.111h2.779v.778h-2.778v2.111h3v.89h-3.89V7.785h3.89v.777zm3.667 5.89h-.889v-5.89h-1.888v-.777h4.666v.777h-1.889v5.89zm5.111 0V7.785h.89v6.666h-.89zm4.667 0h-.889v-5.89h-1.889v-.777H73v.777h-1.889v5.89h.111zm10.556-.89c-.667.667-1.445 1-2.445 1-1 0-1.778-.333-2.444-1-.667-.666-1-1.444-1-2.444s.333-1.778 1-2.445c.666-.666 1.444-1 2.444-1s1.778.334 2.445 1c.666.667 1 1.445 1 2.445 0 1-.334 1.778-1 2.444zm-4.223-.555c.445.444 1.112.778 1.778.778.667 0 1.334-.223 1.778-.778a2.68 2.68 0 00.778-1.89c0-.777-.222-1.444-.778-1.888-.444-.444-1.111-.778-1.778-.778-.666 0-1.333.222-1.778.778a2.68 2.68 0 00-.777 1.889c0 .778.222 1.444.777 1.889zM84 14.452V7.786h1l3.222 5.222V7.786h.889v6.666h-.889l-3.444-5.444v5.444H84zM75.667 24.23c-2.667 0-4.778 2-4.778 4.778a4.742 4.742 0 004.778 4.777c2.666 0 4.777-2 4.777-4.777 0-2.89-2.11-4.778-4.777-4.778zm0 7.555c-1.445 0-2.667-1.222-2.667-2.888 0-1.667 1.222-2.89 2.667-2.89 1.444 0 2.666 1.112 2.666 2.89 0 1.666-1.222 2.889-2.666 2.889zM65.333 24.23c-2.666 0-4.777 2-4.777 4.778a4.742 4.742 0 004.777 4.777c2.667 0 4.778-2 4.778-4.777 0-2.89-2.111-4.778-4.778-4.778zm0 7.555c-1.444 0-2.666-1.222-2.666-2.888 0-1.667 1.222-2.89 2.666-2.89 1.445 0 2.667 1.112 2.667 2.89 0 1.666-1.222 2.889-2.667 2.889zM53 25.675v2h4.778c-.111 1.11-.556 2-1.111 2.555-.667.667-1.778 1.444-3.667 1.444-3 0-5.222-2.333-5.222-5.333S50.11 21.008 53 21.008c1.556 0 2.778.666 3.667 1.444l1.444-1.444c-1.222-1.111-2.778-2-5-2-4 0-7.444 3.333-7.444 7.333s3.444 7.333 7.444 7.333c2.222 0 3.778-.666 5.111-2.11C59.556 30.23 60 28.34 60 26.896c0-.445 0-.89-.111-1.223H53zm50.444 1.555c-.444-1.111-1.555-3-4-3C97 24.23 95 26.119 95 29.008c0 2.666 2 4.777 4.667 4.777 2.111 0 3.444-1.333 3.889-2.11L102 30.562c-.556.778-1.222 1.334-2.333 1.334-1.112 0-1.778-.445-2.334-1.445l6.334-2.667-.223-.555zM97 28.785c0-1.777 1.444-2.777 2.444-2.777.778 0 1.556.444 1.778 1L97 28.785zm-5.222 4.556h2.11V19.452h-2.11v13.89zm-3.334-8.111c-.555-.556-1.444-1.111-2.555-1.111-2.334 0-4.556 2.111-4.556 4.778 0 2.666 2.111 4.666 4.556 4.666 1.111 0 2-.555 2.444-1.11h.111v.666c0 1.778-1 2.778-2.555 2.778-1.222 0-2.111-.89-2.334-1.667l-1.777.778c.555 1.222 1.889 2.777 4.222 2.777 2.444 0 4.444-1.444 4.444-4.888v-8.445h-2v.778zM86 31.785c-1.445 0-2.667-1.222-2.667-2.888 0-1.667 1.222-2.89 2.667-2.89 1.444 0 2.555 1.223 2.555 2.89 0 1.666-1.11 2.889-2.555 2.889zm27.111-12.333h-5v13.89h2.111v-5.223h2.889c2.333 0 4.556-1.667 4.556-4.333 0-2.667-2.223-4.334-4.556-4.334zm.111 6.667h-3V21.34h3c1.556 0 2.445 1.333 2.445 2.333-.112 1.223-1 2.445-2.445 2.445zm12.778-2c-1.556 0-3.111.666-3.667 2.111l1.889.778c.445-.778 1.111-1 1.889-1 1.111 0 2.111.666 2.222 1.777v.112c-.333-.223-1.222-.556-2.111-.556-2 0-4 1.111-4 3.111 0 1.89 1.667 3.111 3.445 3.111 1.444 0 2.111-.666 2.666-1.333h.111v1.111h2v-5.333c-.222-2.445-2.111-3.89-4.444-3.89zm-.222 7.666c-.667 0-1.667-.333-1.667-1.222 0-1.11 1.222-1.444 2.222-1.444.889 0 1.334.222 1.889.444-.222 1.334-1.333 2.223-2.444 2.223zm11.666-7.333l-2.333 6H135l-2.445-6h-2.222L134 32.897l-2.111 4.666H134l5.667-13.11h-2.223zm-18.666 8.89h2.111v-13.89h-2.111v13.89z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.556 8.341c-.334.333-.445.889-.445 1.556v24.555c0 .667.222 1.222.556 1.556l.11.11 13.779-13.777v-.222l-14-13.778z",
    fill: "url(#prefix__paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 27.008l-4.556-4.556v-.333L30 17.563l.111.111 5.445 3.111c1.555.89 1.555 2.334 0 3.223l-5.556 3z",
    fill: "url(#prefix__paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.111 26.897l-4.666-4.667-13.89 13.889c.556.556 1.334.556 2.334.111l16.222-9.333z",
    fill: "url(#prefix__paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.111 17.563L13.89 8.341c-1-.555-1.778-.444-2.333.111L25.444 22.23l4.666-4.667z",
    fill: "url(#prefix__paint3_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M30 26.786l-16.111 9.11c-.889.556-1.667.445-2.222 0l-.111.112.11.11c.556.445 1.334.556 2.223 0L30 26.787z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.12,
    d: "M11.556 35.897c-.334-.334-.445-.89-.445-1.556v.111c0 .667.222 1.223.556 1.556v-.111h-.111zm24-12.223L30 26.786l.111.11 5.445-3.11c.777-.445 1.11-1 1.11-1.556 0 .556-.444 1-1.11 1.444z",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    d: "M13.889 8.452l21.667 12.334c.666.444 1.11.888 1.11 1.444 0-.556-.333-1.111-1.11-1.556L13.889 8.341c-1.556-.889-2.778-.222-2.778 1.556v.11c0-1.666 1.222-2.444 2.778-1.555z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint0_linear",
    x1: 24.222,
    y1: 9.686,
    x2: 5.574,
    y2: 28.332,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.007,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.512,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint1_linear",
    x1: 37.593,
    y1: 22.231,
    x2: 10.708,
    y2: 22.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.409,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.775,
    stopColor: "orange"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint2_linear",
    x1: 27.586,
    y1: 24.781,
    x2: 2.299,
    y2: 50.068,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "prefix__paint3_linear",
    x1: 8.108,
    y1: 0.203,
    x2: 19.4,
    y2: 11.496,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.069,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.476,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.801,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "prefix__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h150v44.46H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.73ba7e755f14a9aa6c858da65b3f46eb.svg";
export { ForwardRef as ReactComponent };